import React from "react"
import "./DefaultFooter.scss"

function DefaultFooter() {
  return <></>
}

export { DefaultFooter }
